import * as React from 'react';
var TabContent = function (props) { return (React.createElement("div", { className: "task-tab-content" }, props.children)); };
export default TabContent;



//////////////////
// WEBPACK FOOTER
// ./src/layout/TabContent.tsx
// module id = 297
// module chunks = 0